import { api } from './client';

export interface PendingSerial {
  id: number;
  serialNo: string;
  receivedAt: string;
  item: { id: number; code: string; name: string; category: string | null };
}

export interface ScanResult {
  serialNo: string;
  scannedAt: string;
  item: { id: number; code: string; name: string; category: string | null };
}

export async function listPendingSerials(itemId?: number): Promise<PendingSerial[]> {
  const params = itemId ? `?itemId=${itemId}` : '';
  const res = await api.get<PendingSerial[]>(`/inventory/wh-entry/pending${params}`);
  return res.data;
}

export async function scanSerial(serialNo: string): Promise<ScanResult> {
  const res = await api.post<ScanResult>('/inventory/wh-entry/scan', { serialNo });
  return res.data;
}
